module.exports = __webpack_public_path__ + "img/powered-by-dark.b64e0307.svg";